import { Method } from "axios";
import { PaginationResult } from "src/interfaces/bold/pagination";
import { CategoryResponse, CreateOrUpdateSalesItemRequest, ImagesResponse,  SalesItemListItem, SalesItemModel, SalesItemsByCategoryRequest, SalesItemsSearchCreteria } from "src/interfaces/bold/salesitem/salesitem";
import { createOrUpdateSalesItem, getAllDiscontinuedSalesItems, getAllPriceLists, getAllSalesItems, getAllSalesItemsPrices, getCategories, getImagesBySku, getPriceListsBySky, getProductInfoBySku, getReferenceDataByProductType, getSalesItemAttributesBySku, getSalesItemById, getSalesItemBySku, getSalesItems, getSalesItemsByCategory, postPriceListBySku, printPriceLabel, removePriceListBySku } from "src/utils/apiRequests";
import useGet from "../useGet";
import useGetAllPaginatedItemsLegacy, { useGetAllPaginatedItems } from "../useGetAllPaginatedItems";
import useResponse, { useResponseLegacy } from "../useResponse";
import { useMemo } from "react";

export const useGetSalesItemById = (id: number): SalesItemModel => {
    const [salesItem] = useResponseLegacy<SalesItemModel>(getSalesItemById, { id }, true);
    return salesItem;
}

export const useGetSalesItemBySku = (sku: string, dependency =null): SalesItemModel => {
    const [salesItem] = useResponseLegacy<SalesItemModel>(getSalesItemBySku, { sku }, true, dependency);
    return salesItem;
}

export const useGetSalesItems = (sc: SalesItemsSearchCreteria) => {
    const [salesItems] = useResponseLegacy<PaginationResult<SalesItemListItem>>(getSalesItems, sc)
    return salesItems;
}


export const useGetSalesItemsByCategory = (si: SalesItemsByCategoryRequest): PaginationResult<SalesItemListItem> => {
    const [salesItems] = useResponseLegacy<PaginationResult<SalesItemListItem>>(getSalesItemsByCategory, si)
    return salesItems;
}




export const useGetAllSalesItems = (shouldRequest= true) => {
    return useGetAllPaginatedItems<SalesItemListItem[]>({requestFunction:getAllSalesItems, pageSize:500, idField:"ArticleNumber",  shouldRequest});
}
export const useGetSalesItemPrices = (priceListId?: number | string | null) => {
    const requestValues = useMemo(
        () => (priceListId ? { priceListId } : null),
        [priceListId]
    );

    return useGetAllPaginatedItems<SalesItemListItem>({
        requestFunction: getAllSalesItemsPrices,
        pageSize: 500,
        idField: "SalesItemId",
        requestValues,
        shouldRequest: !!priceListId,
    });
};
export const useGetAllDiscontinuedSalesItems = (shouldRequest: boolean) => {
    const result = useGetAllPaginatedItemsLegacy<SalesItemListItem[]>(getAllDiscontinuedSalesItems, 500, "ArticleNumber", null, shouldRequest);
    if (!shouldRequest) return { rows: null, status: "idle" };
    return result;
}


export const useLatestSalesItems = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllSalesItems,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}

export const usePrintPriceLabel = (salesItemId: string, priceListId: number) => {
    const {rows: result} = useResponse<Blob>({requestFunction:printPriceLabel,values:{salesItemId, priceListId}, requestNothingOnNull:true, responseType:"blob"});
    return result;
}


export const useCreateOrUpdateSalesItem = (salesItem: CreateOrUpdateSalesItemRequest, method: Method = "POST", id: number = null) => {
    const request = createOrUpdateSalesItem(salesItem, method, id);
    const result = useGet<SalesItemModel>(request);
    return result;
}
export const useProductInfo = (sku: string, languageId?: number, dependecy?) => {
    const [productInfo] = useResponseLegacy<any>(getProductInfoBySku, { sku, languageId }, true, [languageId, dependecy]);
    return productInfo;
}
export const useGetSalesItemAttributes = (sku: string) => {
    const [salesItemAttributes] = useResponseLegacy<any>(getSalesItemAttributesBySku, { sku }, true);
    return salesItemAttributes;
}
export const useGetSalesItemAttributeReferenceData = (productTypeId: number) => {
    const [referenceData ] = useResponseLegacy<any>(getReferenceDataByProductType, { productTypeId }, true, productTypeId);
    return referenceData;
}

export const useProductImages = (sku: string, dependency = null) => {
    const [images] = useResponseLegacy<ImagesResponse[]>(getImagesBySku, { sku }, true, dependency);
    return images;
}
export const usePriceListBySku = (sku: string | number) => {
    const [priceList] = useResponseLegacy<any>(getPriceListsBySky, { sku }, true);
    return priceList;
}
export const useGetSalesAssortmentsWithPriceLists = () =>{
       const response = useResponse<any[]>({requestFunction:getAllPriceLists});
       return response;
}

export const useUpdatePriceListBySku = (priceListPost) => {
    const sku = priceListPost?.sku;
    const newPriceLists = priceListPost?.priceList;
    const request = postPriceListBySku(sku, newPriceLists);
    const {results, abort, status} = useGet(request, newPriceLists );
    return results;
}

export const usRemovePriceListBySku = (priceListPost) => {
    const sku = priceListPost?.sku;
    const removePriceLists = priceListPost?.priceList;
    const request = removePriceListBySku(sku, removePriceLists);
    const{results, abort, status} = useGet(request, removePriceLists );
    return results;
}


export const useGetCategories = (inputLanguage?,dependency = null) => {
    const [categories] = useResponseLegacy<CategoryResponse[]>(getCategories,{inputLanguage},false,dependency);
    return categories;
}
